import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// types
import { IPosition, IUser } from 'types/graphql'
// views
import { AvatarWrapper } from 'components/PageComponents/Home/components/DashboardWidgets/components/StrategyActions/components/Content/components/TasksList/views'
// utils
import { get } from 'lodash'
import { safeGetOr } from 'utils/fp'

// styled
const Wrapper = styled('div')<{ src: string }>`
  align-items: center;
  background-color: ${colors.gray350};
  border-radius: 50%;
  border: ${({ src }) => (src ? 'none' : `2px solid ${colors.white}`)};
  color: ${colors.white100};
  display: flex;
  justify-content: center;
  margin-right: -8px;
  overflow: hidden;
`

const Image = styled.img`
  height: 100%;
  object-fit: cover;
  text-align: center;
  width: 100%;
`

// types
interface AvatarProps {
  user?: IUser & IPosition
  counter?: string
}

interface AvatarsListProps {
  list: IUser[] | IPosition[] | any
  limit: number
}

const Avatar: React.FC<AvatarProps> = ({ user: userOrPosition, counter }) => {
  let position: IPosition, description: string

  if (get(userOrPosition, 'description')) {
    position = userOrPosition
    description = safeGetOr<any, any, any>('', 'description[0]')(position)
  } else if (counter) {
    description = counter
  } else {
    description =
      safeGetOr<any, any, any>('', 'firstName[0]')(userOrPosition) +
      safeGetOr<any, any, any>('', 'lastName[0]')(userOrPosition)
  }

  const src: string = get(userOrPosition, 'avatarUrl')

  return <Wrapper src={src}>{src ? <Image src={src} alt='avatar' /> : description}</Wrapper>
}

const AvatarsList: React.FC<AvatarsListProps> = ({ list, limit }) => {
  return (
    <AvatarWrapper>
      {list.map((role, index) => {
        const id = get(role, 'user.id') || get(role, 'position.id') || index

        if (index === limit && list.length !== limit + 1) {
          return <Avatar key={id} counter={`+${list.length - index}`} />
        }

        if (index > limit) {
          return null
        }

        return <Avatar key={id} user={role.user || role.position} />
      })}
    </AvatarWrapper>
  )
}

export default AvatarsList
